exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul.flex {\n    flex: unset !important;\n}\nli.flex {\n    flex: unset !important;\n}\n.child-flex > *, .flex {\n    flex: unset !important;\n}\nli.mt-1.ml-1.mb-0.flex.justify-between.content-center {\n    flex: unset;\n    flex-grow: unset;\n    flex-shrink: unset;\n    flex-basis: unset;\n}\n", ""]);

// exports
